import React, { useState } from 'react'
import Button from '../Button'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'react-modal'
import studygameActions from '../../store/actions/studygameActions'

const GameButtons = () => {
    const dispatch = useDispatch()
    const skips = useSelector(state => state.studyGame.skips)
    const [state, setState] = useState(false)

    return (
        <section>
            <hr className='mb-6' />
            <div className='flex flex-wrap items-center float-right mt-5'>
                <Button className='mb-4 md:mb-0' onClick={() => setState(true)}>Abandonar partida</Button>
                <Button
                    className='mr-0'
                    disabled={skips === 0 ? true : false}
                    onClick={() => skips !== 0 && dispatch(studygameActions.finishMinigame(skips))}
                >
                    Saltar ronda ({skips})
                </Button>
                <Modal
                    isOpen={state}
                    contentLabel="Modal de confimação"
                    className='modal py-6 px-6'
                    ariaHideApp={false}
                    closeTimeoutMS={200}
                    shouldCloseOnOverlayClick={true}
                    disableAutoFocus={true}
                    onAfterClose={() => setState(false)}
                    onRequestClose={() => setState(false)}
                >
                    <h3 className='p-0'>Prentende desistir da partida?</h3>
                    <p className='py-6'>Se estiver a ter dificuldades utilize a fonte da notícia para pesquisar mais acerca da mesma.</p>
                    <div className='flex justify-end flex-wrap'>
                        <Button onClick={() => setState(false)}>Voltar</Button>
                        <Button
                            className='mr-0'
                            onClick={() => {
                                setState(false)
                                dispatch(studygameActions.quitGame())
                            }}
                        >
                            Desistir
                        </Button>
                    </div>
                </Modal>
            </div>
        </section>
    )
}

export default GameButtons
